import { useEffect } from 'react';

export default function useUnmount(cleanup: () => void) {
  useEffect(() => {
    return () => cleanup();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
